import { render, staticRenderFns } from "./order-invoice-template3.vue?vue&type=template&id=c1cc2e50"
import script from "./order-invoice-template3.vue?vue&type=script&lang=js"
export * from "./order-invoice-template3.vue?vue&type=script&lang=js"
import style0 from "./order-invoice-template3.vue?vue&type=style&index=0&id=c1cc2e50&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports